import React, { useState, useEffect } from "react"
import { RadioSelect, RadioLabel, CurrencyRow } from '../components'
import {CONVERTIBLE_CURRENCIES, radius, themeColors} from '../constants'

// Full supported-currency list (codes match the backend Currency catalog /
// ExchangeRateService::WHITELIST). Rendered with emoji flags so every currency
// is selectable without per-currency flag assets.
const currencies = CONVERTIBLE_CURRENCIES.map((c) => ({
  id: c.code,
  name: c.code,
  displayName: c.label,
  flag: c.flag,
}))

const useCurrencySelect = ({
  initialValue,
  callback
}) => {
  const [value, setValue] = useState((initialValue ? initialValue : ""));
  const [query, setQuery] = useState('')

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleSelectChange = (object) => {
    setValue(object.id)
    if (callback) { callback(object.id) }
  }

  const q = query.trim().toLowerCase()
  const filtered = q
    ? currencies.filter((c) => c.name.toLowerCase().includes(q) || (c.displayName || '').includes(query.trim()))
    : currencies

  const createLabel = ({ object, handleChange }) => {
    return <RadioLabel
      key={object.name}
      object={object}
      value={object.id}
      checked={value === String(object.id)}
      changed={handleChange}>
      <CurrencyRow flag={object.flag} code={object.name} label={object.displayName} />
    </RadioLabel>
  }

  const select = (
    <div>
      <div style={styles.searchWrap}>
        <span style={{ marginRight: 8 }}>🔍</span>
        <input
          style={styles.search}
          type="text"
          placeholder="搜尋幣別（USD、美元…）"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      <RadioSelect
        createLabel={createLabel}
        objects={filtered}
        changed={handleSelectChange}
      />
    </div>
  )

    return [value, select, currencies];
}

export default useCurrencySelect;

const styles = {
  label: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchWrap: {
    position: 'sticky', top: 0, zIndex: 1,
    display: 'flex', alignItems: 'center',
    background: themeColors.gray300, borderRadius: radius.md, padding: '8px 12px', margin: '8px',
  },
  search: { border: 'none', outline: 'none', background: 'transparent', flex: 1, fontSize: '14px' },
}
